import { useState } from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

const ValuesTabs = () => {
  const { t } = useTranslation()
  const [activeTabIndex, setActiveTabIndex] = useState(null)

  const tabs = t('values.tabs', { returnObjects: true })
  // Ensure tabs is an array before using it, in case of loading state or issue
  const safeTabs = Array.isArray(tabs) ? tabs : []

  return (
    <section className="relative min-h-screen bg-[#f5f5f5] py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl h-full flex flex-col justify-center">
        <h2 className="text-3xl font-bold text-black mb-10">{t('values.title')}</h2>
        <div className="mt-10 grid gap-8 lg:grid-cols-3">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, ease: 'easeOut', delay: 0.4 }}
            viewport={{ once: true, amount: 0.3 }}
            className="lg:col-span-2 order-1 lg:order-2"
          >
            <div className="rounded-2xl bg-white p-8 shadow min-h-[240px] flex flex-col justify-center text-black">
              {activeTabIndex !== null && safeTabs[activeTabIndex] ? (
                <>
                  <h3 className="text-xl font-bold text-black">{safeTabs[activeTabIndex].title}</h3>
                  <p className="mt-4 text-xl text-gray-800 leading-relaxed">{safeTabs[activeTabIndex].content}</p>
                </>
              ) : (
                <p className="text-3xl font-bold leading-relaxed text-black">{t('values.quote')}</p>
              )}
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, ease: 'easeOut', delay: 0.3 }}
            viewport={{ once: true, amount: 0.3 }}
            className="order-2 lg:order-1"
          >
            <ul className="space-y-2">
              {safeTabs.map((tab, index) => {
                const isActive = activeTabIndex === index
                return (
                  <li key={index}>
                    <button
                      type="button"
                      onClick={() => setActiveTabIndex(index)}
                      className={`w-full px-4 py-3 text-left text-sm font-semibold uppercase tracking-[0.15em] transition ${isActive ? 'bg-gray-200 text-black' : 'bg-primary text-black hover:bg-primary-dark'
                        }`}
                      aria-pressed={isActive}
                    >
                      {tab.title}
                    </button>
                  </li>
                )
              })}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default ValuesTabs
